import { V as VideoControl, d as defineCustomElement$1 } from './video-control.js';

const TaroVideoControl = VideoControl;
const defineCustomElement = defineCustomElement$1;

export { TaroVideoControl, defineCustomElement };
